import { Component, ElementRef, HostListener, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-action-menu',
  templateUrl: './action-menu.component.html',
  styleUrls: ['./action-menu.component.scss']
})
export class ActionMenuComponent implements OnInit {
  @Input() isLarge: boolean = false;
  @Input() uid: String = "";
  isOpen: boolean = false;

  @HostListener('document:click', ['$event'])
  clickout(event: Event) {
    let ele = event.target as Element;
    if(this.eRef.nativeElement.contains(event.target) && ele.nodeName !== "LI") {
    } else {
      this.close();
    }
  }

  constructor(private eRef: ElementRef) {
  }

  open() {
    this.isOpen = true;
  }

  close() {
    this.isOpen = false;
  }

  ngOnInit(): void {
  }

}
